<div class="modal-header">
  <div class="modal-header__close-link" [mat-dialog-close]>
    <span class="close" [mat-dialog-close]></span>
  </div>
</div>
<div class="image-preview">
  <img [src]="imageUrl | safe" alt="">
</div>
